import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import axios from 'axios';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { ShimmerPostDetails } from 'react-shimmer-effects';
import './PublicReport.css';

const PublicReport = () => {
  const { id } = useParams();
  const [publicReport, setPublicReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPublicReport = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/open/v1/public-reports/${id}`
        );
        
        if (response.data.status && response.data.publicReport) {
          setPublicReport(response.data.publicReport);
        } else {
          setError('Report not found');
        }
      } catch (error) {
        console.error('Error fetching public report:', error);
        setError('Failed to load report');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchPublicReport();
    } else {
      setError('Invalid report ID');
      setLoading(false);
    }
  }, [id]);

  if (loading) {
    return (
      <div className="description-container">
        <div className="shimmer-loading">
          <ShimmerPostDetails card imageHeight={300} caption />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="description-container">
        <div className="error-message">Error: {error}</div>
      </div>
    );
  }

  if (!publicReport) {
    return (
      <div className="description-container">
        <div className="error-message">No report found</div>
      </div>
    );
  }

  return (
    <div className="description-container">


      <div className="light-blue" style={{textAlign: 'center', margin: '30px 0', padding: '20px', borderRadius: '12px'}}>
        <h1>DMCA Dent | Public Report</h1>
      </div>

      <div id="pdf-content">
        <div className="product-details">
          <div className="product-images">
            {publicReport.snapshot && (
              <div>
                <h4>Face Snapshot</h4>
                <Zoom>
                  <img loading="lazy" src={publicReport.snapshot} alt="Face Snapshot" className="product-image" />
                </Zoom>
              </div>
            )}

            {publicReport.productImageUrl && (
              <div>
                <h4>Product Image</h4>
                <Zoom>
                  <img loading="lazy" src={publicReport.productImageUrl} alt="Product" className="product-image" />
                </Zoom>
              </div>
            )}
          </div>
        </div>

        <div className="suggestions-section">
          <h3>Suggested Products</h3>
          <div className="suggestions-container">
            {publicReport.suggestionProductImageUrl && publicReport.suggestionProductImageUrl.length > 0 ? (
              publicReport.suggestionProductImageUrl.map((imageUrl, index) => (
                <div key={index} className="suggestion-item">
                  <h4>Suggested Product {index + 1}</h4>
                  <Zoom>
                    <img loading="lazy" src={imageUrl} alt={`Suggestion ${index + 1}`} className="suggestion-image" />
                  </Zoom>
                </div>
              ))
            ) : (
              <p>No suggestions available</p>
            )}
          </div>
        </div>

        <div className="patient-info-box">
          <h2>Patient & Denture Measurement Report</h2>
          <div className="info-grid">
            <div className="info-card light-blue">
              <label>Age</label>
              <span>{publicReport.age}</span>
            </div>

            <div className="info-card light-blue">
              <label>Nostrils Width</label>
              <span>{publicReport.nostrilWidth} mm</span>
            </div>

            {publicReport.name && (
              <div className="info-card light-green">
                <label>Name</label>
                <span>{publicReport.name}</span>
              </div>
            )}
            
            {publicReport.phone && (
              <div className="info-card light-purple">
                <label>Phone</label>
                <span>{publicReport.phone}</span>
              </div>
            )}
            
            {publicReport.email && (
              <div className="info-card light-yellow">
                <label>Email</label>
                <span>{publicReport.email}</span>
              </div>
            )}

            <div className="info-card light-blue">
              <label>Report Generated</label>
              <span>{new Date(publicReport.createdAt).toLocaleDateString()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicReport;
